import { useState } from 'react'

import _ from 'lodash'

import AppBar from '@mui/material/AppBar'
import Toolbar from '@mui/material/Toolbar'
import Button from '@mui/material/Button'

import { enqueueSnackbar } from 'notistack'

import {saveAppleModel,saveAppleTemplate,saveGoogleData, saveScannerConfiguration} from "/providers/templates-api"

export default ({ apiSource, apiKeys, prevButtonState, nextButtonState, activeStep, setActiveStep, templateId,appleModel,
  appleTemplate,objectData,classData, originalModel,setOriginalModel, originalTemplate,setOriginalTemplate, originalClassData,
  setOriginalClassData, originalObjectData,setOriginalObjectData, scannerData,originalScannerData, setOriginalScannerData}) => {

  const [saving,setSaving] = useState(false)

  const next = async () => {
    setActiveStep(activeStep + 1)

    let promises = []

    if (!_.isEqual(originalModel,appleModel)) {
      promises.push(saveAppleModel({ apiSource, apiKeys, templateId, appleModel }))
      setOriginalModel(appleModel)
    }
    
    if (!_.isEqual(originalTemplate,appleTemplate)) {
      promises.push(saveAppleTemplate({ apiSource, apiKeys, templateId, appleTemplate }))
      setOriginalTemplate(appleTemplate)
    }

    if (!_.isEqual(originalClassData,classData) || !_.isEqual(originalObjectData,objectData)) {
      saveGoogleData({ apiSource, apiKeys, templateId, googleClass:classData, googleObject:objectData })
      setOriginalClassData(classData)
      setOriginalObjectData(objectData)
    }

    if (!_.isEqual(originalScannerData,scannerData)) {
      promises.push(saveScannerConfiguration({ apiSource, apiKeys, templateId, scannerData }))
      setOriginalScannerData(scannerData)
    }

    if (promises.length) {
      setSaving(true)
      enqueueSnackbar({ message: 'Saving progress', variant: 'light' })

      await Promise.all(promises)
    }


    if (promises.length) {
      setSaving(false)
      enqueueSnackbar({ message: 'Progress saved', variant: 'success' })
    }
  }

  const prev = () => {
    setActiveStep(activeStep - 1)
  }

  return (
    <AppBar position="sticky" color="secondary" sx={{ top: 'auto', bottom: 0 }}>
      <Toolbar className="app_footer">
        <div className="flex flex-row justify-between w-full">
          <PrevButton state={prevButtonState} activeStep={activeStep} click={prev} saving={saving}/>
          <NextButton state={nextButtonState} activeStep={activeStep} click={next} saving={saving}/>
        </div>
      </Toolbar>
    </AppBar>
  )
}


const PrevButton = ({ state, activeStep, click, saving }) => {
  switch (state) {
    case "hidden": return <div />
    default: return <Button variant="outlined" onClick={() => click(activeStep - 1)} disabled={state === "disabled" || saving} color='secondary'>Back</Button>
  }
}

const NextButton = ({ state, activeStep, click, saving }) => {
  switch (state) {
    case "hidden": return <div />
    default: return <Button variant="outlined" onClick={() => click(activeStep + 1)} disabled={state === "disabled" || saving} color='secondary'>Next</Button>
  }
}